import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Typography, Button} from '@material-ui/core'
import {removeItemFromCart, removeAllItemsFromCart, addTimeToCart} from '../ReduxActions/CartActions'
import '../stylesheets/Cart.css';

import IconButton from '@material-ui/core/IconButton';
import {Delete as DeleteIcon} from '@material-ui/icons';

import {Container, Col, Row, Card, Image} from 'react-bootstrap'

class Cart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      holder: undefined,
      discounts: 0,
      estimatedTotal: this.props.Cart.totalPrice
    }
  }

  handleCheckout = () => {
    console.log("handle checkout");
  }

  handleSignIn = () => {
    console.log("Handle sign in");
  }

  handleDeleteItem = (item) => e => {
    console.log("Handle Delete: ", item);

    this.props.dispatchRemoveFromCart(item);
  }

  render() {

    // Variant Name and Variant Value
    const ConditionalVariant = (theItem) => {
      let item = theItem.item;
      if (item.variantName && item.variantValue) {
        return (
          <Row className="justify-content-space-between">
            <Typography variant="subtitle1" style={{marginBottom: 10}}>{item.variantName}:</Typography>
            <Typography variant="subtitle2" style={{marginBottom: 10}}>{item.variantValue}</Typography>
          </Row>
        )
      }
      return null;
    }

    // Rider Profile (If an item is a bike)
    const ConditionalRiderProfile = (theItem) => {
      let item = theItem.item;
      if (item.is_bike && item.riderProfile) {
        return (
          <div>
            {/* Helmet */}
            {
              item.riderProfile.helmet ? (
                <Row className="justify-content-space-between">
                  <Typography variant="subtitle1" style={{marginBottom: 10}}>Helmet:</Typography>
                  <Typography variant="subtitle2" style={{marginBottom: 10}}>{item.riderProfile.helmet}</Typography>
                </Row>
              ) : null
            }

            {/* Bike Pedals */}
            {
              item.riderProfile.bikePedals ? (
                <Row className="justify-content-space-between">
                  <Typography variant="subtitle1" style={{marginBottom: 10}}>Bike Pedals:</Typography>
                  <Typography variant="subtitle2" style={{marginBottom: 10}}>{item.riderProfile.bikePedals}</Typography>
                </Row>
              ) : null
            }

            {/* Rider Height */}
            {
              item.riderProfile.riderHeight ? (
                <Row className="justify-content-space-between">
                  <Typography variant="subtitle1" style={{marginBottom: 10}}>Rider Height (cm): </Typography>
                  <Typography variant="subtitle2" style={{marginBottom: 10}}>{item.riderProfile.riderHeight}</Typography>
                </Row>
              ) : null
            }

            {/* Seat Height */}
            {
              item.riderProfile.barDrop ? (
                <Row className="justify-content-space-between">
                  <Typography variant="subtitle1" style={{marginBottom: 10}}>Seat Height: </Typography>
                  <Typography variant="subtitle2" style={{marginBottom: 10}}>{item.riderProfile.seatHeight}</Typography>
                </Row>
              ) : null
            }

            {/* Bar Drop */}
            {
              item.riderProfile.barDrop ? (
                <Row className="justify-content-space-between">
                  <Typography variant="subtitle1" style={{marginBottom: 10}}>Bar Drop: </Typography>
                  <Typography variant="subtitle2" style={{marginBottom: 10}}>{item.riderProfile.barDrop}</Typography>
                </Row>
              ) : null
            }

            {/* Bar Reach */}
            {
              item.riderProfile.barReach ? (
                <Row className="justify-content-space-between">
                  <Typography variant="subtitle1" style={{marginBottom: 10}}>Bar Reach: </Typography>
                  <Typography variant="subtitle2" style={{marginBottom: 10}}>{item.riderProfile.barReach}</Typography>
                </Row>
              ) : null
            }
          </div>
        )

        // All optionalrider profile items exist: Bar Drop, Bar Reach, Seat Height
        // if (item.riderProfile.barDrop && item.riderProfile.barReach && item.riderProfile.seatHeight) {
        //   return (

        //   )
        // }
      }
      return null;
    }

    const RenderCartItems = () => (
      <div>
          {
            this.props.Cart.items.map(item => (
              <div className="cart-border" style={{flex: 1}}>
                <Container fluid style={{marginBottom: 10}}>
                  <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                    <Typography variant="h6">{item.title}</Typography>
                    <IconButton key="delete" color="inherit" onClick={this.handleDeleteItem(item)}><DeleteIcon style={{fontSize: 20}} /></IconButton>
                  </div>
                  
                  <Typography variant="body1" style={{marginBottom: 10}}>{item.city}, {item.country}</Typography>
                  <Row>
                  <Col xs={3}>
                    <Image src={item.img_url} thumbnail />
                  </Col>
                  <Col xs={9}>
                    {/* Show Item customizable options */}
                    <div style={{marginLeft: '20%', marginRight: 10}}>
                      {/* Price Per Item */}
                      <Row className="justify-content-space-between">
                        <Typography variant="subtitle1" style={{marginBottom: 5}}>Price:</Typography>
                        <Typography variant="subtitle2" style={{marginBottom: 5}}>${item.price}.00</Typography>
                      </Row>

                      {/* Conditional Variant Name and Variant Value */}
                      <ConditionalVariant item={item} />

                      {/* Conditional Bike Rider Profile */}
                      <ConditionalRiderProfile item={item} />
                    </div>

                  </Col>
                  </Row>
                </Container>
              </div>
            ))
          }
      </div>
    )

    if (this.props.Cart.items && this.props.Cart.items.length > 0) {
      let itemName = "item";
      if (this.props.Cart.items.length > 0) {
        itemName = "items";
      }
      return (
        <div className="custom-container">
          <Typography variant="h3" style={{marginBottom: 10}}>My Cart</Typography>
          {/* <Typography variant="h6" style={{marginBottom: 10}}>${this.props.Cart.totalPrice}.00</Typography> */}

          <Row>

            {/* Cart Items View */}
            <Col xs={12} lg={8}>
              <RenderCartItems />
            </Col>
    
    
            {/* Checkout/Order Summary */}
            <Col xs={12} lg={4}>
              <div className="cart-border">
                <div style={{marginLeft: 10, marginRight: 10, marginTop: 10, marginBottom: 10}}>
                  <Typography variant="h5" style={{marginBottom: 10, fontWeight: "500"}}>Order Summary</Typography>

                  {/* Subtotal and total number of items */}
                  <div className="custom-row">
                    <Typography variant="subtitle2" style={{fontWeight: "500"}}>SUBTOTAL:</Typography>
                    <Typography variant="body1">${this.props.Cart.totalPrice}.00</Typography>
                  </div>
                  <Typography variant="body1">{this.props.Cart.items.length} {itemName}</Typography>
                  <hr/>

                  {/* Shipping */}
                  <div className="custom-row">
                    <Typography variant="subtitle2" style={{fontWeight: "500"}}>SHIPPING:</Typography>
                    <Typography variant="body1">TBD</Typography>
                  </div>
                  <hr/>

                  {/* Discounts */}
                  <div className="custom-row">
                    <Typography variant="subtitle2" style={{fontWeight: "500"}}>DISCOUNTS:</Typography>
                    <Typography variant="body1">${this.state.discounts}.00</Typography>
                  </div>
                  <hr />


                  {/* Estimated Total */}
                  <div className="custom-row">
                    <Typography variant="subtitle2" style={{fontWeight: "500"}}>ESTIMATED TOTAL:</Typography>
                    <Typography variant="body1">${this.state.estimatedTotal}.00</Typography>
                  </div>
                  <Typography variant="body2" style={{fontWeight: "300"}}>Tax calculated at checkout</Typography>

                  {/* Checkout Buttons */}
                  <Button size="large" fullWidth onClick={this.handleCheckout} variant="contained" style={{color: 'white', backgroundColor: "#45b97c", marginTop: 30}}>Guest Checkout</Button>

                  <Button size="large" fullWidth onClick={this.handleSignIn} color="inherit" variant="outlined" style={{color: 'black', marginTop: 15}}>Sign In</Button>

                </div>
              </div>
            </Col>
          </Row>
          <div style={{marginTop: 40}}>
          </div>
        </div>
      )
    }
    else {
      return (
        <div className="custom-container">
        <Typography variant="h3" style={{marginBottom: 10}}>My Cart</Typography>

        </div>
      )
    }

  }
}

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth,
    Cart: state.Cart
  }
}

const mapDispatchToProps = {
  dispatchRemoveFromCart: (product) => removeItemFromCart(product),
  dispatchRemoveAllItemsFromCart: (sessionId) => removeAllItemsFromCart(sessionId),
  dispatchAddCartTime: (sessionId) => addTimeToCart(sessionId)
}


export default connect(mapStateToProps, mapDispatchToProps)(Cart);